<template>
  <v-card title="节假日维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item label="导入模板">
                <a href="../../../static/other/节假日导入.xlsx"
                  >节假日导入.xlsx</a
                >
              </v-form-item>
              <v-upload
                :action="action"
                :accept="xml"
                multiple
                @change="onChange"
              >
                <v-button type="ghost">
                  <v-icon type="upload"></v-icon>点击上传
                </v-button>
              </v-upload>
            </div>
          </v-col>
          <v-col class="gutter-row" span="16">
            <div style="text-align: right">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="cx_ssnd"
                  placeholder="所属年度"
                  valueFormat="yyyy"
                  type="year"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <v-popconfirm
              title="确定删除吗?"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      xml: ".xlsx",
      action: "api/system/jjrwh/upload-jjrwh-list",
      cx_ssnd: new Date().getFullYear().toString(),
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "rq",
            title: "日期",
            align: "center",
          },
          {
            field: "lx",
            title: "类型",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let lx = row.lx == 1 ? "休息" : "上班";
                return [<span>{lx}</span>];
              },
            },
          },
          {
            field: "ssnd",
            title: "所属年月",
            align: "center",
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios
        .get("api/system/jjrwh/get-jjrwh-list?ssnd=" + this.cx_ssnd)
        .then((res) => {
          this.tableData = res.data.data;
        });
    },
    del: function (row) {
      this.$axios.get("api/system/jjrwh/del-jjrwh-list?id=" + row.id).then((res) => {
        if (res.data.code == 200) {
          this.$message["success"](res.data.message);
          this.findList();
        } else {
          this.$message["error"](res.data.message);
        }
      });
    },
    onChange(info) {
      if (info.file.response) {
        if (info.file.response.code == "200") {
          this.$message["success"](info.file.response.message);
          this.findList();
        } else {
          this.$message["error"](info.file.response.message);
        }
      }
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/jjrwh.vue